<template>
    <div style="z-index: 1060;">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div v-if="!token || stage ==4">
            <AppCustomerRegisteration />
        </div>
        <div v-else>
            <div>
                <div class="text-center mt-4">
                    <div>
                        <div class="user-header mr-4 ml-4">
                            <img width="80px" class="avatarImg" :src="userProfile.avatar">
                            <div class="ml-4 text-left d-flex align-items-center">
                                <div>
                                    <h5 class="mb-2">
                                        {{ userProfile.name }} <img width="20px" class="ml-1"
                                            v-if="getLoginChannelIcon(userProfile.provider) !== null"
                                            :src="getLoginChannelIcon(userProfile.provider)">
                                    </h5>
                                    <div class="ml-3 ">
                                        <h6 class="row"><i class="fi fi-rr-mobile-notch mr-1"></i> {{ userProfile.phone
                                        }}
                                        </h6>
                                        <h6 v-if="userProfile.registeredEmail" class="row mb-0"><i
                                                class="fi fi-rr-user-lock mr-1"></i> {{
                                                    userProfile.registeredEmail
                                                }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-left mt-4 d-flex justify-content-center">
                        <div class="menu-user-list mr-4 ml-4 mb-5">
                            <CListGroup>
                                <CListGroupItem class="list-group-item-user"
                                    @click="$router.push('/delivery/user/details')">
                                    <div class="row">
                                        <div class="col-2 text-left pt-1"><i class="fi fi-rr-user"></i></div>
                                        <div class="col-7 text-left">{{ $t('personalInfo') }}</div>
                                        <div class="col-3 text-right pt-1"><i class="fi fi-rr-angle-right"></i></div>
                                    </div>
                                </CListGroupItem>
                                <!-- <CListGroupItem class="list-group-item-user"
                                    @click="$router.push('/delivery/user/addresses')">
                                    <div class="row">
                                        <div class="col-2 text-left pt-1"><i class="fi fi-rr-marker"></i></div>
                                        <div class="col-7 text-left">{{ $t('deliveryAddress') }}</div>
                                        <div class="col-3 text-right pt-1"><i class="fi fi-rr-angle-right"></i></div>
                                    </div>
                                </CListGroupItem> -->
                                <CListGroupItem class="list-group-item-user"
                                    @click="$router.push('/delivery/history?source=all')">
                                    <div class="row">
                                        <div class="col-2 text-left pt-1"><i class="fi fi-rr-ballot"></i></div>
                                        <div class="col-7 text-left">{{ $t('allPurchaseHistory') }}</div>
                                        <div class="col-3 text-right pt-1"><i class="fi fi-rr-angle-right"></i></div>
                                    </div>
                                </CListGroupItem>
                                <CListGroupItem class="list-group-item-user">
                                    <div class="row">
                                        <div class="col-2 text-left pt-1"><i class="fi fi-rr-interrogation"></i></div>
                                        <div class="col-7 text-left">{{ $t('helpCenter') }}</div>
                                        <div class="col-3 text-right pt-1"><i class="fi fi-rr-angle-right"></i></div>
                                    </div>
                                </CListGroupItem>
                                <CListGroupItem class="list-group-item-user" data-toggle="modal"
                                    data-target="#logout-modal">
                                    <!-- <CListGroupItem @click="logOut()"> -->
                                    <div class="row">
                                        <div class="col-2 text-left pt-1"><i class="fi fi-rr-exit"></i></div>
                                        <div class="col-7 text-left">{{ $t('signOut') }}</div>
                                        <div class="col-3 text-right pt-1"><i class="fi fi-rr-angle-right"></i></div>
                                    </div>
                                </CListGroupItem>
                            </CListGroup>
                        </div>
                    </div>
                    <span class="mt-5">
                        Powered by
                        <img src="/silom-pos.png" width="5%" alt="" class="img-fluid" />
                        Silom POS
                    </span>
                </div>
            </div>
        </div>

        <div class="modal fade small-modal" id="logout-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body d-flex align-items-center justify-content-center text-center flex-column">
                        <h1 class="pt-2"> <i class="fi fi-rs-sign-out-alt"></i></h1>
                        <h4 class="mt-3 text-center">{{ $t('dialogSignOut') }}</h4>
                    </div>
                    <div class="modal-footer p-0 d-flex  justify-content-center mt-3">
                        <button style="width: 45%;border-radius: 60px;" @click="showModal = false" type="button"
                            class="btn h4 btn-secondary " data-dismiss="modal">{{
                                $t('cancel')
                            }}</button>
                        <button style="width: 45%;border-radius: 60px;" type="button" class="btn h4 btn-danger"
                            @click="logOut()" data-dismiss="modal">{{
                                $t('confirm') }}</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import pos from '@/services/pos'
import AppPushNotification from '@/components/AppPushNotification.vue'
import AppCustomerRegisteration from '@/components/AppCustomerRegisteration.vue'
import { extractProfileFromToken,restoreTokenFromQuery } from '@/util/auth.util';
import moment from 'moment';
import '@/util/delivery.css'
import jwt from 'jsonwebtoken';

export default {
    components: {
        VuePhoneNumberInput,
        AppPushNotification,
        AppCustomerRegisteration
    },
    data() {
        return {
            phoneNumber: '',
            stage: 0,
            alertBox: false,
            alertText: '',
            OTPModel: ['', '', '', '', '', ''],
            timeLeft: 180,
            intervalId: null,
            timeLeftOTP: 300,
            intervalOTPSession: null,
            loading: false,
            responeOTP: null,
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            username: '',
            email: '',
            userProfile: {},
            showModal: true,
        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        token() {
            return localStorage.getItem('token') || null
        },
        phone() {
            return localStorage.getItem('phone') || ''
        },
        shopObjectId() {
            return localStorage.getItem('shopObjectId')
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        validateEmail() {
            if (this.email !== '') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                return emailRegex.test(this.email)
            } else {
                return true
            }

        },
    },
    created() {
        const shopObjectId = localStorage.getItem('shopObjectId');
        const uid = localStorage.getItem('uid');

        
        if (!shopObjectId || !uid) {
            console.warn('No shopObjectId or uid found, redirecting to /delivery/cokeshopt');
            this.$router.push('/delivery/cokeshopt');
            return; 
        }
        if (this.$route.query.requiredphone === 'true') {
            this.stage = 4;
        }
        this.getUserProfileDetails()
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
        clearInterval(this.intervalOTPSession)
    },
    methods: {
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        async saveUser() {
            try {
                this.loading = true
                const phone = this.phoneNumber.replace(/\s/g, '')
                const uid = localStorage.getItem('uid')
                const token = localStorage.getItem('token') || this.token

                let data = {
                    name: this.username,
                    phone: phone,
                }
                if (this.email !== '') {
                    data.email = this.email
                }

                if (this.username !== '' && phone !== '' && this.validateEmail) {
                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile`,
                        method: 'post',
                        data: data,
                        headers: {
                            authorization: token
                        },
                    })
                    if (res.data.error.code == 0) {
                        const resMember = await pos({
                            url: `/api/v1.3/${uid}/profile/member`,
                            method: 'post',
                            data: {
                                profileObjectId: res.data.data.objectId,
                                shop: {
                                    objectId: this.shop.objectId,
                                    id: this.shop.id,
                                    branchName: this.shop.branchName,
                                }
                            },
                            headers: {
                                authorization: localStorage.getItem('token')
                            }
                        })
                        if (resMember.data.error.code == 0) {
                            console.log('Created Profile and Added Member Success')
                            this.showNotification(this.$i18n.t('createProfileSuccess'), '', 'success')
                            let resToken = await pos({
                                url: `/auth/v1.0/renewtoken/otp`,
                                method: 'post',
                                data: {
                                    "refreshToken": localStorage.getItem('refreshToken')
                                }
                            })
                            console.log('[After Renew] token =', resToken.data?.data?.token);
                            if (resToken.data?.error?.code == 0) {
                                localStorage.setItem('token', resToken.data?.data?.token)
                                this.getUserProfileDetails()
                            }
                            window.location.href = '/delivery/menulists'
                            this.$forceUpdate()
                            this.loading = false
                        } else {
                            this.showNotification('ERROR ' + resMember.data.error.code, '', 'danger')
                            this.loading = false
                        }
                    } else {
                        console.log(res)
                        this.showNotification('ERROR ' + res.data.error.code, '', 'danger')
                        this.loading = false
                    }
                } else {
                    if (this.validateEmail == false) {
                        this.showNotification(this.$i18n.t('validateEmail'), '', 'danger')
                    } else {
                        this.showNotification(this.$i18n.t('nameInputInvalid'), '', 'danger')
                    }
                    this.loading = false
                }
            } catch (error) {
                this.showNotification('ERROR ' + error, '', 'danger')
                console.error(error);
                this.loading = false
            }
        },
        startCountdown() {
            this.timeLeft = 180
            this.timeLeftOTP = 300
            clearInterval(this.intervalId)
            clearInterval(this.intervalOTPSession)
            this.intervalId = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--
                } else {
                    clearInterval(this.intervalId)
                }
            }, 1000)
            this.intervalOTPSession = setInterval(() => {
                if (this.timeLeftOTP > 0) {
                    this.timeLeftOTP--
                } else {
                    this.stage = 0
                    clearInterval(this.intervalOTPSession)
                }
            }, 1000)
        },
        moveToNext(index) {
            if (this.OTPModel.every(item => item !== '')) {
                this.verifyOTP()
                return
            }
            if (this.OTPModel[index].length === 1 && index < this.OTPModel.length - 1) {
                this.$refs[`otp${index + 1}`][0].focus()
            }
        },
        moveToPrevious(index, event) {
            if (event.key === 'Backspace' && index > 0 && !this.OTPModel[index]) {
                this.$refs[`otp${index - 1}`][0].focus()
            }
        },
        async sendOTP() {
            if (this.$refs.phone_number_input.isValid) {
                this.startCountdown()
                window.scrollTo(0, 0)
                this.stage = 1
                this.phoneNumber = this.phoneNumber.replace(/\s/g, '')
                if (!this.phoneNumber.startsWith('0')) {
                    this.phoneNumber = '0' + this.phoneNumber;
                }
                try {
                    const res = await pos({
                        url: '/sms/v1.0/otp?dryrun=true',
                        data: { number: this.phoneNumber },
                        method: 'post',
                    })
                    this.responeOTP = res.data.data
                } catch (error) {
                    console.error(error)
                }
            } else {
                this.setAlert(this.$i18n.t('validateTel'))
            }
        },
        reSendOTP() {
            this.sendOTP()
            this.startCountdown()
        },
        async getUserProfileDetails() {
            try {
                if (localStorage.getItem('token')) {
                    const phone = localStorage.getItem('phone')
                    const uid = localStorage.getItem('uid')
                    const profileObjectId = localStorage.getItem('profileObjectId')  
                    
                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile?objectId=${profileObjectId}`,
                        method: 'get',
                        headers: {
                            token: `${localStorage.getItem('token')}`
                        }
                    });
                    if (res.data.error.code == 0) {
                        this.userProfile = res.data.data
                        localStorage.setItem('objectId', this.userProfile.objectId)
                        localStorage.setItem('profile', JSON.stringify(this.userProfile))
                        this.userProfile.avatar ||= 'https://cdn-icons-png.flaticon.com/512/847/847969.png';
                    }
                     else if (res.data.error.code == 402) {
                        this.renewToken()
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getUserProfile() {
            try {
                const phone = this.phoneNumber.replace(/\s/g, '')
                const uid = localStorage.getItem('uid')
                localStorage.setItem('phone', phone)

                const res = await pos({
                    url: `/api/v1.3/${uid}/profile`,
                    method: 'get',
                    params: {
                        phone: phone,
                    },
                    headers: {
                        authorization: localStorage.getItem('token') || this.token,
                    },
                })
                if (res.data.error.code == 0) {
                    localStorage.setItem('objectId', res.data.data.objectId)
                    localStorage.setItem('profile', JSON.stringify(res.data.data))
                    //Save Profile as Shop Member
                    const resMember = await pos({
                        url: `/api/v1.3/${uid}/profile/member`,
                        method: 'post',
                        data: {
                            profileObjectId: res.data.data.objectId,
                            shop: {
                                objectId: this.shop.objectId,
                                id: this.shop.id,
                                branchName: this.shop.branchName,
                            }
                        },
                    })
                    this.loading = false
                    window.location.href = '/delivery/menulists'
                    this.$forceUpdate()
                } else if (res.data.error.code == 4000) {
                    this.loading = false
                    this.stage = 2
                }
            } catch (error) {
                console.error(error);
            }
        },
        async verifyOTP() {
            const invalisDigits = this.OTPModel.some(item => item === '')
            const OTPString = this.OTPModel.join('')


            if (!invalisDigits) {
                const data = {
                    number: this.responeOTP.number,
                    ref: this.responeOTP.ref,
                    expire: this.responeOTP.expire,
                    otp: OTPString
                }
                window.scrollTo(0, 0)
                this.loading = true
                try {
                    const res = await pos({
                        url: '/sms/v1.0/otp/verify',
                        data: data,
                        method: 'post',
                    })
                    if (res.data.data.verified) {
                        localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('refreshToken', res.data.data.refreshToken)
                        let resToken = await pos({
                            url: `/auth/v1.0/renewtoken/otp`,
                            method: 'post',
                            data: {
                                "refreshToken": res.data.data.refreshToken
                            }
                        })
                        if (resToken.data?.error?.code == 0) {
                            localStorage.setItem('token', resToken.data?.data?.token)
                        }

                        this.getUserProfile()
                        this.loading = false
                    } else {
                        this.loading = false
                        this.setAlert(this.$i18n.t('validateOTP'))
                    }
                } catch (error) {
                    console.error(error)
                    this.loading = false
                }
            } else {
                this.setAlert(this.$i18n.t('validateOTP'))
            }
        },
        setAlert(alertText) {
            this.showNotification(alertText, '', 'danger')
        },
        backwardStage() {
            if (this.stage === 0) {
                this.$router.push('/delivery/home')
            }
            if (this.stage === 2) {
                localStorage.removeItem('token')
            }
            this.OTPModel = ['', '', '', '', '', '']
            this.stage--
            this.startCountdown()
        },
        getLoginChannelIcon(provider) {
            switch (provider) {
                case "LINE":
                    return '/img/line.png'
                case "GMAIL":
                    return '/img/google.png'
                case "APPLE_ID":
                    return '/img/apple-logo.png'
                default:
                    return null
            }
        },
        formatIsoDate(isoDate) {
            if (!isoDate) return '';
            return moment(isoDate).format('DD/MM/YYYY, HH:mm:ss');
        }
    },
}
</script>

<style>
.country-selector__input {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.input-tel.lg.has-value .input-tel__input[data-v-e59be3b4] {
    padding-top: 0px;
    font-size: large;
}

.input-tel.lg .input-tel__label[data-v-e59be3b4] {
    font-size: 0px;
    visibility: hidden;
}

.slide-enter-active {
    transition: transform 1.0s ease, opacity 1.0s ease;
}

.slide-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-enter-active {
    transform: translateX(100%);
    opacity: 1;
}

.slide-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.div-transition {
    height: 100vh;
}
</style>